// extracted by mini-css-extract-plugin
export var emptyState = "_56-d";
export var statCard = "_56-c";
export var table = "_56-0";
export var tableCell = "_56-4";
export var tableCellClickable = "_56-5 _56-4";
export var tableCellDefault = "_56-6 _56-4";
export var tableCellEmpty = "_56-8";
export var tableCellWithValue = "_56-7";
export var tableContainer = "_56-e";
export var tableHeaderWeight = "_56-1";
export var tableHeaderZone = "_56-2";
export var tableRowHeader = "_56-3";
export var viewModeButton = "_56-9";
export var viewModeButtonActive = "_56-a _56-9";
export var viewModeButtonInactive = "_56-b _56-9";